import { SET_CURRENT_DATA } from './types'

// Set current viewable data
export const setCurrentData = (data) => {
	return { type: SET_CURRENT_DATA, payload: data }
}
